import gql from 'graphql-tag';

export const ParticipantTaskTemplates = gql`
  query ParticipantTaskTemplates($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      participantTaskTemplates {
        id
        name
        requiresDueDate
        recurrence {
          intervalDays
          completedAt
        }
        labels {
          id
          organizationId
          type
          name
          color
          description
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;
